import {AxiosError} from "axios";
import {needAuth} from "../instance/Instance";

/**
 * POST /process/{documentId}
 * @param {number|string} documentId
 * @param {{ type: string, content: string, workTime?: string, operatorId?: number }} contents
 * @param {Array<{ object?: File }|File>} [files]
 */
export async function workSave(documentId, contents, files = []) {
    const formData = new FormData();
    formData.append(
        "contents",
        new Blob([JSON.stringify(contents)], {type: "application/json"}),
    );

    files.forEach((file) => {
        const payload = file?.object ?? file;
        if (payload) {
            formData.append("files", payload);
        }
    });

    try {
        return await needAuth.post(`/process/${documentId}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    } catch (error) {
        if (error instanceof AxiosError) {
            return {
                status: error.response?.status,
                data: error.response?.data,
            };
        }
        return error;
    }
}

/**
 * PUT /process/{reworkId}
 * @param {number|string} reworkId
 * @param {{ type: string, content: string, workTime?: string, operatorId?: number }} contents
 * @param {Array<{ object?: File }|File>} [files]
 */
export async function workUpdate(id, reworkId, contents, files = []) {
    const formData = new FormData();
    formData.append(
        "contents",
        new Blob([JSON.stringify(contents)], {type: "application/json"}),
    );

    files.forEach((file) => {
        const payload = file?.object ?? file;
        if (payload) {
            formData.append("files", payload);
        }
    });

    try {
        return await needAuth.put(`/process/${id}/${reworkId}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    } catch (error) {
        if (error instanceof AxiosError) {
            return {
                status: error.response?.status,
                data: error.response?.data,
            };
        }
        return error;
    }
}

/**
 * PUT /process/done/{type}/{documentId}
 * @param {string} type
 * @param {number|string} documentId
 * @param {{ type: string, content: string, workTime?: string, operatorId?: number }} contents
 */
export async function workDone(type, documentId, contents) {
    const formData = new FormData();
    formData.append(
        "contents",
        new Blob([JSON.stringify(contents)], {type: "application/json"}),
    );

    try {
        return await needAuth.put(`/process/done/${type}/${documentId}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    } catch (error) {
        if (error instanceof AxiosError) {
            return {
                status: error.response?.status,
                data: error.response?.data,
            };
        }
        return error;
    }
}

/**
 * POST /process/review/{reworkId}
 * @param {number|string} reworkId
 * @param {{ type: string, opinion: string, pass?: boolean, newDeadline?: string }} contents
 */
export async function reviewSave(reworkId, contents) {
    const formData = new FormData();
    formData.append(
        "contents",
        new Blob([JSON.stringify(contents)], {type: "application/json"}),
    );

    try {
        return await needAuth.post(`/process/review/${reworkId}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    } catch (error) {
        if (error instanceof AxiosError) {
            return {
                status: error.response?.status,
                data: error.response?.data,
            };
        }
        return error;
    }
}

/**
 * POST /process/review/{documentId}/{reworkId}
 * @param {number|string} documentId
 * @param {number|string} reworkId
 * @param {{ type: string, opinion: string, pass: boolean, newDeadline?: string }} contents
 */
export async function reviewConfirm(documentId, reworkId, contents) {
    const formData = new FormData();
    formData.append(
        "contents",
        new Blob([JSON.stringify(contents)], {type: "application/json"}),
    );

    try {
        return await needAuth.post(`/process/review/${documentId}/${reworkId}`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        });
    } catch (error) {
        if (error instanceof AxiosError) {
            return {
                status: error.response?.status,
                data: error.response?.data,
            };
        }
        return error;
    }
}
